import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { UiColors } from 'assets/styles/old/global';

/* Shared cell renderers for the new-UI list tables (plain text, a name link, the action wrapper). */
export const Text = styled.span`
  color: ${UiColors.forestColor};
`;

/**
 * The link style for every cell in a new-design table — link-blue and underlined, so a clickable
 * value is recognisable as one without having to hover the row first.
 *
 * Single source of truth: the list tables, the campaign assignment cells and the media tabs all
 * render this (directly or via a `styled(NameLink)` that adds layout), so restyling table links
 * anywhere in the app is a change here and nowhere else.
 */
export const NameLink = styled(Link)`
  font-weight: 600;
  color: var(--link-color);
  text-decoration: underline;

  /* Always underlined, so hover thickens the rule instead of adding it. */
  &:hover {
    text-decoration-thickness: 2px;
  }
`;

/**
 * Wrapper for a cell whose link is rendered by a legacy cell component (the visits list's date goes
 * through <TimeCell/> → <LinkCell/>). Those anchors already use --link-color, but at the default
 * weight, so beside a <NameLink/> in the same row they read as a lighter blue. This lifts them to
 * the NameLink weight so every link in a row is the same blue.
 */
export const LegacyLinkCell = styled.div`
  a {
    font-weight: 600;
  }
`;

/**
 * Wrapper for the reused <ActionCell /> (edit / survey icons). Neutralises ActionCell's legacy
 * CellWrapper margins/padding (scoped here so the shared ActionCell stays untouched) and centers
 * the icons with an even gap. Hover/colour belong to ActionCell's own IconButton.
 */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: auto;
    margin: 0;
    padding: 0;
    gap: 16px;
    justify-content: center;
  }
`;
